import { Link } from "react-router-dom";
import { COMPANY } from "@/config/company";

/** Compact legal footer for pages that do not use PublicLayout (login, sign-up). */
export default function LegalLine({ className = "" }) {
  return (
    <div className={`text-center text-[11px] leading-relaxed text-slate-500 ${className}`} data-testid="legal-line">
      <p>{COMPANY.brandLine}</p>
      <p>{COMPANY.addressOneLine}</p>
      <p>CIN {COMPANY.cin} &middot; GSTIN {COMPANY.gstin} &middot; {COMPANY.phone} &middot; {COMPANY.email}</p>
      <p className="mt-1">
        <Link to="/privacy-policy" className="underline hover:text-slate-700">Privacy</Link> &middot;{" "}
        <Link to="/terms" className="underline hover:text-slate-700">Terms</Link> &middot;{" "}
        <Link to="/refund-cancellation-policy" className="underline hover:text-slate-700">Refunds</Link> &middot;{" "}
        <Link to="/shipping-policy" className="underline hover:text-slate-700">Shipping</Link> &middot;{" "}
        <Link to="/contact" className="underline hover:text-slate-700">Contact</Link>
      </p>
    </div>
  );
}
